import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faCog } from '@fortawesome/pro-solid-svg-icons';

import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';
import StatusLabel from 'components/status_label';
import { pluralize } from 'helpers/formatters/string_formats';
import PredictionSummary from 'components/project/prediction_summary';
import ListingQuickUpdateModal from 'components/listing/quick_update/modal';
import { updateListing } from 'components/project/actions';

const listingFieldsIdMap = {
  'condo': 'condosFields',
  'lot': 'lotsFields',
  'lease space': 'leaseFields'
};

export class ListingRollup extends React.Component {
  static propTypes = {
    editLink: PropTypes.string.isRequired,
    features: PropTypes.shape({
      backoffice: PropTypes.bool,
      pipeline: PropTypes.bool,
    }).isRequired,
    history: PropTypes.object.isRequired,
    listings: PropTypes.arrayOf(PropTypes.shape({
      daysLikelyToClose: PropTypes.number,
      estimatedGrossCommission: PropTypes.number,
      percentageLikelyToClose: PropTypes.number
    })).isRequired,
    listingType: PropTypes.string,
    status: PropTypes.string.isRequired,
    updateListing: PropTypes.func.isRequired
  };

  state = {
    listingForEditing: this.props.listings[0],
    expanded: false,
    showListingEditModal: false
  };

  displayName = (listing) => {
    if (listing.address2 && listing.address2.length > 0) return listing.address2;

    return `${this.props.listingType} ${listing.number}`;
  }

  showListingEditModal = (listingForEditing) => {
    this.setState({
      listingForEditing,
      showListingEditModal: true
    });
  };

  goToVoucherTab = () => {
    this.props.history.push('/vouchers');
  }

  handleListingUpdate = (listing) => {
    this.hideListingEditModal();
    this.props.updateListing(listing);
  };

  hideListingEditModal = () => {
    this.setState({ showListingEditModal: false });
  };

  toggleExpanded = () => {
    this.setState(({ expanded }) => ({ expanded: !expanded }));
  }

  renderGroupHeader() {
    return (
      <div className="row-eq-height py-2 clickable" name="toggle-predictions" onClick={this.toggleExpanded}>
        <span className="mr-4">
          <FontAwesomeIcon
            className={this.props.listings.length === 0 ? 'invisible' : ''}
            icon={this.state.expanded ? faChevronUp : faChevronDown}
          />
        </span>
        <h3 className="grow m-0" name="listings-label">
          {pluralize(this.props.listings.length, this.props.listingType)}
        </h3>
        <StatusLabel.Pill className="listing-rollup-label" status={this.props.status} />
      </div>
    );
  }

  renderListings() {
    if (!this.state.expanded) return;
    const { editLink, listings, listingType, status } = this.props;
    const { backoffice, pipeline } = this.props.features;

    return listings.map((listing, index) => {
      const showBorder = index < listings.length - 1;
      const closed = status === 'closed';

      const dropdownItems = [];
      if (backoffice && !closed) {
        dropdownItems.push(
          <MenuItem key="vouchers-tab" name="go-to-voucher-tab" onClick={this.goToVoucherTab}>Go To Vouchers</MenuItem>
        );
      }
      if ((backoffice && !closed) || pipeline) {
        dropdownItems.push(
          <MenuItem key="modal" name="update-prediction-link" onClick={() => this.showListingEditModal(listing)}>
            Update{closed ? '' : ' Prediction'}
          </MenuItem>
        );
      }

      dropdownItems.push(
        <MenuItem href={`${editLink}#${listingFieldsIdMap[listingType.toLowerCase()]}`} key="edit-link">
          Edit {listingType}
        </MenuItem>
      );

      return (
        <div className={`py-4 ${showBorder ? 'border-bottom' : ''}`} key={listing.id}>
          <div className="row-eq-height mb-3">
            <div className="grow">
              <strong>{this.displayName(listing)}</strong>
              <span className="text-muted ml-3">{listing.spaceAvailable}</span>
            </div>

            <Dropdown dropup={true} id={`listing-menu-${listing.id}`}>
              <UnstyledDropdownToggle bsRole="toggle" id={`listing-button-${listing.id}`} variant="dark">
                <FontAwesomeIcon className="space-settings" icon={faCog} size="lg" />
              </UnstyledDropdownToggle>

              <Dropdown.Menu className="dropdown-menu-right">
                {dropdownItems}
              </Dropdown.Menu>
            </Dropdown>
          </div>

          <PredictionSummary {...listing} />
        </div>
      );
    });
  }

  render() {
    return (
      <React.Fragment>
        {this.renderGroupHeader()}
        {this.renderListings()}

        {this.props.listings.length > 0 &&
          <ListingQuickUpdateModal
            features={this.props.features}
            key={this.state.listingForEditing.id}
            listing={this.state.listingForEditing}
            show={this.state.showListingEditModal}
            onCancel={this.hideListingEditModal}
            onSave={this.handleListingUpdate}
          />
        }
      </React.Fragment>
    );
  }
}

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps, { updateListing })(withRouter(ListingRollup));
